const PREFIX = "donation_"; // 可选：为所有 key 添加前缀，避免冲突

class LocalStorageUtil {
  // 设置值（自动区分字符串 / 对象）
  static set(key, value) {
    try {
      // 如果是对象或数组，自动转为 JSON
      if (typeof value === "object") {
        localStorage.setItem(key, JSON.stringify(value));
      } else {
        // 普通字符串、数字、布尔都直接存
        localStorage.setItem(key, value);
      }
    } catch (error) {
      console.error("LocalStorage SET Error:", error);
    }
  }

  static isUsableObject(value) {
    return (
      value !== null &&
      typeof value === "object" &&
      Object.keys(value).length > 0
    );
  }

  static saveGoods(goods) {
    if (!this.isUsableObject(goods)) {
      console.warn("LocalStorageUtil.saveGoods: goods 无效，已忽略", goods);
      return;
    }
    this.set(`${PREFIX}goods`, goods);
  }

  static getGoods(fallback = null) {
    const goods = this.get(`${PREFIX}goods`);
    if (this.isUsableObject(goods)) {
      return goods;
    }
    return fallback;
  }

  static ensureGoods(goodsCandidate, fallback = {}) {
    if (this.isUsableObject(goodsCandidate)) {
      this.saveGoods(goodsCandidate);
      return goodsCandidate;
    }

    const cachedGoods = this.getGoods();
    if (cachedGoods) {
      return cachedGoods;
    }

    if (this.isUsableObject(fallback)) {
      return fallback;
    }

    console.warn("LocalStorageUtil.ensureGoods: 无可用商品数据，返回空对象");
    return {};
  }

  // 获取值（自动 JSON 解析）
  static get(key) {
    try {
      const value = localStorage.getItem(key);

      if (value === null || value === undefined) {
        return null; // 不存在返回 null
      }

      // 尝试解析 JSON，如果不是 JSON 则直接返回原字符串
      try {
        return JSON.parse(value);
      } catch {
        return value; // 普通字符串
      }
    } catch (error) {
      console.error("LocalStorage GET Error:", error);
      return null;
    }
  }

  // 删除
  static remove(key) {
    localStorage.removeItem(key);
  }

  // 清空所有 localStorage
  static clear() {
    localStorage.clear();
  }

  static saveAd(adData) {
    this.set(`${PREFIX}ad`, adData);
  }

  static getAd() {
    return this.get(`${PREFIX}ad`);
  }

  static saveStUsername(stUsername) {
    this.set(`${PREFIX}st_username`, stUsername);
  }

  static getStUsername() {
    return this.get(`${PREFIX}st_username`);
  }

  static saveOrderNo(orderNo) {
    this.set(`${PREFIX}orderNo`, orderNo);
  }

  static getOrderNo() {
    return this.get(`${PREFIX}orderNo`);
  }

  static saveProductInfo(productInfo) {
    this.set(`${PREFIX}productInfo`, productInfo);
  }

  static getProductInfo() {
    return this.get(`${PREFIX}productInfo`);
  }

  static saveOrderDetail(orderDetail) {
    this.set(`${PREFIX}orderDetail`, orderDetail);
  }

  static getOrderDetail() {
    return this.get(`${PREFIX}orderDetail`);
  }

  // 记录用户在结算页的合规同意（仅本地存储，不发给后端）
  static saveCheckoutConsent(consentInfo) {
    this.set(`${PREFIX}checkoutConsent`, consentInfo);
  }

  static getCheckoutConsent() {
    return this.get(`${PREFIX}checkoutConsent`);
  }

  static savePixel(pixel) {
    this.set(`${PREFIX}pixel`, pixel);
  }

  static getPixel() {
    return this.get(`${PREFIX}pixel`);
  }

  static saveFbqToken(token) {
    this.set(`${PREFIX}fbqToken`, token);
  }

  static getFbqToken() {
    return this.get(`${PREFIX}fbqToken`);
  }

  static saveTgid(tgid) {
    this.set(`${PREFIX}tgid`, tgid);
  }

  static getTgid() {
    return this.get(`${PREFIX}tgid`);
  }

  static saveGroupId(groupId) {
    this.set(`${PREFIX}group_id`, groupId);
  }

  static getGroupId() {
    return this.get(`${PREFIX}group_id`);
  }

  // 保存用于发送邮件的模板 emailId
  static saveEmailId(emailId) {
    if (!emailId) return;
    this.set(`${PREFIX}emailId`, emailId);
  }

  static getEmailId() {
    return this.get(`${PREFIX}emailId`);
  }

  // 保存从 langlist 解析出来的配置（例如 brielle 配置）
  static saveLangConfig(config) {
    if (!this.isUsableObject(config)) {
      console.warn(
        "LocalStorageUtil.saveLangConfig: config 无效，已忽略",
        config
      );
      return;
    }
    this.set(`${PREFIX}lang_config`, config);
  }

  static getLangConfig() {
    return this.get(`${PREFIX}lang_config`);
  }
}

export default LocalStorageUtil;
